import { getUserAnalyticsSummary } from '../api/analyticsApi';
import { useAnalyticsResource } from './useAnalyticsResource';

/** Totals and DAU/WAU/MAU. */
export const useAnalyticsSummary = (requestFilters, options) =>
  useAnalyticsResource(getUserAnalyticsSummary, requestFilters, options);
